import { Popover } from "antd";
import { CommentComponent } from "../commentComponent";
import { ReviewDecisionComponent } from "../reviewDecisionComponent";
import "./index.scss";
import { ExclamationCircleFilled } from "@ant-design/icons";

function DecisionAndReasoningComponentWithRejectedNotification({
  record,
  reviewStatus,
  selectedRowKeys,
  resetTask,
  removeEditedReviewTasks,
  upsertEditedReviewTasks,
  userDetails,
  handleClearSaved,
  calculatedDisabled,
  rejectedTaskReason,
  ...restProps
}) {
  return (
    <div className="review-decision-and-reasoning-with-rejected-notification-container">
      {rejectedTaskReason ? (
        <div className="rejected-notification-container">
          <Popover content={rejectedTaskReason} trigger="hover" getPopupContainer={restProps.getPopupContainer}>
            <ExclamationCircleFilled style={{ color: "#C34A36", fontSize: "16px" }} />
          </Popover>
        </div>
      ) : null}
      <div className="review-decision-and-reasoning-container">
        <ReviewDecisionComponent
          selected={record.decision}
          mandatory={record.isActionRequired}
          disabled={!(reviewStatus && record.hasEditAccess) || selectedRowKeys.length > 0}
          handleChange={(action) => {
            if (!action) {
              resetTask(record);
              removeEditedReviewTasks([record.reviewTaskId]);
            } else {
              upsertEditedReviewTasks({
                ...record,
                action,
                comment: null,
                decisionReason: null,
                reviewedBy: userDetails.fullName,
                reviewedAt: new Date().toISOString(),
              });
            }
          }}
          verificationStatus={record.verificationStatus}
          allowClear={!(record.isSaved() && !record.isCurrentDecisionDifferentFromOriginal())}
          handleClearSaved={() => handleClearSaved(record)}
          placeHolder={undefined}
          handleClear={undefined}
          getPopupContainer={restProps.getPopupContainer}
        />
        <CommentComponent
          comment={record.reviewerComment}
          disabled={calculatedDisabled(record)}
          onChange={({ comment, decisionReason }) =>
            upsertEditedReviewTasks({
              ...record,
              comment,
              decisionReason,
              action: record.decision,
              reviewedBy: userDetails.fullName,
              reviewedAt: new Date().toISOString(),
            })
          }
          getPopupContainer={restProps.getPopupContainer}
          taskId={record.reviewTaskId}
          onlyComment={record.isReasonNotRequired()}
          selectedReason={record.decisionReason}
        />
      </div>
    </div>
  );
}

export default DecisionAndReasoningComponentWithRejectedNotification;
